export default __webpack_public_path__ + "static/media/banner-1.78528335.jfif";